import { useState, useEffect } from 'react';

const useFade = (params: FadeHookConfig) => {
	const [fade, setFade] = useState(params.overrideInitialFade);
	const [isFading, setFading] = useState(!params.overrideInitialFade);
	const [isMounted, setMounted] = useState(false);
	const [isUnmounting, setOnUnmount] = useState(false);


	const setFadeOut = (unmount?: boolean) => {
		setFading(true);
		setFade(false);
		if (unmount) {
			setOnUnmount(unmount);
		}
	};

	const handleDelayedFadeOut = (unmount: boolean) => {
		setTimeout(() => {
			setFadeOut(unmount);
		}, params.delay || 250);
	};

	const setFadeIn = (customDelay?: number, onMount?: boolean) => {
		if (!fade && isFading && !isUnmounting) {
			let initialTimeout = customDelay || params.delay || 250;
			if (onMount && customDelay) initialTimeout = params.initialDelay || customDelay;
			setFading(false);
			setTimeout(() => {
				setFade(true);
			}, initialTimeout);
		}
	};
	

	useEffect(() => {
		if (!isMounted && !params?.disableFadeInOnMount) {
			setFadeIn(150, true);
		}
		setMounted(true);
		return () => {
			setOnUnmount(true);
			setFadeOut();
		};
	}, []);

	useEffect(() => {
		if (isMounted && !params.disableAutoFadeout) {
			setFadeIn();
		}

		if (fade && params.singleFade) {
			handleDelayedFadeOut(true);
		}
	},[fade]);

	return {
		fadeClass: fade ? `!opacity-100 ${params.classOnVisible || ''}` : `!opacity-0 ${params.classBeforeVisible || ''}`,
		onFadeIn: setFadeIn,
		onFadeOut: setFadeOut,
		fade,
		fadeStyle: { transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)', transitionProperty: 'opacity', transitionDuration: params.transitionDuration || '1000ms' }
	};
};

interface FadeHookConfig {
	disableAutoFadeout?: boolean;
	overrideInitialFade?: boolean;
	initialDelay?: number;
	disableFadeInOnMount?: boolean;
	classBeforeVisible?: string,
	classOnVisible?: string,
	delay?: number,
	transitionDuration?: string,
	singleFade?: boolean;
}

export default useFade;